var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import "pixi-spine";
import "pixi.js";
import { utilAnimation } from "../../utils/animation/utilAnimation";
import { utilTick } from "../../utils/utilTick";
import { IdAnimDog, ListDogAnimation } from "../IdAnimDog";
import { StateBuildingGraphics } from "../StateBuildingGraphics";
var Container = PIXI.Container;
var BF2DoghouseDog = /** @class */ (function (_super) {
    __extends(BF2DoghouseDog, _super);
    function BF2DoghouseDog() {
        var _this = _super.call(this) || this;
        _this.AnimScale = 0.15;
        _this.state = StateBuildingGraphics.Idle;
        _this.playRandomAnimations = function (stateList) {
            _this.randomAnimations = utilTick
                .getInterval$(BF2DoghouseDog.DogAnimInterval)
                .subscribe(function () { return _this.animateRandomDogState(stateList); });
        };
        _this.updateState = function (buildingState, idleAnimation, unsubscribe, onCompleteFn) {
            _this.state = buildingState;
            if (_this.dogAnim) {
                return _this.update(idleAnimation, unsubscribe, onCompleteFn);
            }
            return undefined;
        };
        _this.animateRandomDogState = function (stateList, onCompleteFn) {
            if (stateList === void 0) { stateList = ListDogAnimation.Idle; }
            if (utilAnimation.isAnimationEnabled()) {
                var randomIdleState = stateList[Math.floor(Math.random() * stateList.length)];
                return _this.updateState(StateBuildingGraphics.Idle, randomIdleState, false, onCompleteFn);
            }
            return undefined;
        };
        _this.init = function () {
            _this.dogAnim = utilAnimation.getSpineAnimation(BF2DoghouseDog.DogAnimId);
            // Hide hat slots for now
            _this.dogAnim.skeleton.slots.forEach(function (slot) {
                if (slot.data.name.toLowerCase().indexOf("hat") !== -1) {
                    if (slot != undefined) {
                        if (slot.currentSprite && slot.currentSprite.visible) {
                            slot.currentSprite.visible = false;
                        }
                        else if (slot.currentMesh && slot.currentMesh.visible) {
                            slot.currentMesh.visible = false;
                        }
                    }
                }
            });
            _this.dogAnim.pivot.set(_this.dogAnim.width * 0.5, _this.dogAnim.height * 0.5);
            _this.dogAnim.scale.set(_this.AnimScale, _this.AnimScale);
            _this.update();
            _this.addChild(_this.dogAnim);
        };
        _this.update = function (idleAnimation, unsubscribe, onCompleteFn) {
            if (utilAnimation.isAnimationEnabled()) {
                if (idleAnimation != undefined) {
                    return _this.handleAnimation(idleAnimation, unsubscribe, onCompleteFn);
                }
                else {
                    switch (_this.state) {
                        case StateBuildingGraphics.Idle:
                            return _this.handleAnimation(IdAnimDog.Idle, unsubscribe, onCompleteFn);
                        case StateBuildingGraphics.RunningProduction:
                            return _this.handleAnimation(IdAnimDog.Sniff, unsubscribe, onCompleteFn);
                        case StateBuildingGraphics.FinishedProduction:
                            return _this.handleAnimation(IdAnimDog.IdleHappy, unsubscribe, onCompleteFn);
                    }
                }
            }
            return undefined;
        };
        _this.handleAnimation = function (animationType, unsubscribe, onCompleteFn) {
            if (unsubscribe === void 0) { unsubscribe = false; }
            if (unsubscribe) {
                _this.stopRandomAnimations();
            }
            var animation = _this.dogAnim.state.setAnimation(BF2DoghouseDog.AnimTrackIdx, animationType, false);
            var instance = _this;
            animation.listener = {
                complete: function (entry) {
                    instance.updateState(StateBuildingGraphics.Idle);
                    if (onCompleteFn) {
                        onCompleteFn();
                    }
                    if (unsubscribe) {
                        instance.playRandomAnimations();
                    }
                },
            };
            return animation;
        };
        _this.stopRandomAnimations = function () {
            if (_this.randomAnimations) {
                _this.randomAnimations.unsubscribe();
            }
        };
        utilAnimation.getAnimLoaded$(BF2DoghouseDog.DogAnimId).subscribe(_this.init);
        return _this;
    }
    BF2DoghouseDog.prototype.setup = function (_a) {
        var scale = _a.scale;
        this.AnimScale = scale;
    };
    BF2DoghouseDog.DogAnimId = "dog";
    BF2DoghouseDog.AnimTrackIdx = 0;
    BF2DoghouseDog.DogAnimInterval = 7500;
    return BF2DoghouseDog;
}(Container));
export { BF2DoghouseDog };



//////////////////
// WEBPACK FOOTER
// ./src/graphics/outskirts/BF2DoghouseDog.ts
// module id = 864
// module chunks = 3